import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { RouterLink, RouterOutlet } from '@angular/router';
import { ResearchComponentsCoreModule } from '@corteva-research/ngx-components-core';

import { BadgeModule } from 'primeng/badge';
import { OverlayBadgeModule } from 'primeng/overlaybadge';
import { ToastModule } from 'primeng/toast';

import { SETTINGS, Settings } from './app.settings';
import { IAppUser } from './services/insecta';
import { LoaderService } from './services/loader.service';
import { MSGraphService } from './services/msgraph.service';
import { VersionService } from './services/version.serivce';

import { AppUserSettingsComponent } from './components/app-user-settings/app-user-settings.component';
import { AppInitService, IInsectaPermissions } from './services/app-init.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    ResearchComponentsCoreModule,
    RouterLink,
    CommonModule,
    ToastModule,
    BadgeModule,
    OverlayBadgeModule,
    AppUserSettingsComponent
  ],
  providers: [{ provide: ResearchComponentsCoreModule, useValue: undefined }],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  public title = 'Insecta';
  isProd: boolean;
  environment: string | undefined;
  permissions!: IInsectaPermissions;
  appUser!: IAppUser;
  sites: any[] = [];

  constructor(
    public versionService: VersionService,
    public loaderService: LoaderService,
    public msGraphService: MSGraphService,
    private appInit: AppInitService,
    @Inject(SETTINGS) private settings: Settings
  ) {
    this.isProd = this.settings.isProd;
    this.environment = this.settings.environment;
  }

  ngOnInit() {
    this.permissions = this.appInit.permissions;
    this.appUser = this.appInit.appUser;
  }
}
